import * as actions from '../actions/operator-cancellation-terms';
import * as models from '../../domain/models';
import * as _ from 'lodash';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  terms: models.CancellationTerms;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  terms: null,
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD_CANCELLATION_TERMS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case actions.LOAD_CANCELLATION_TERMS_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        terms: _.cloneDeep(action.payload),
      };
    }

    case actions.LOAD_CANCELLATION_TERMS_FAIL: {
      return {
        ...initialState,
        isLoading: false,
        isLoaded: false,
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getTerms = (state: State) => state.terms;
